export default __webpack_public_path__ + "static/media/O-086.728d000c.png";